import React, {
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
  forwardRef,
} from "react";
import Header3 from "../components/Header3";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Modal } from "react-bootstrap";
import { color } from "chart.js/helpers";
import { useNavigate } from "react-router-dom";
import SocketContext from "../context/SocketContext";
import { ChatState } from "../context/ChatProvider";
import toast from "react-hot-toast";
import axios from "../AxiosInstance";
import { FaVideo } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { BASE_URL, Frontend } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import {
  CalendarDays,
  MapPin,
  User,
  Globe,
  Crown,
  Share2,
  Check,
  ChevronDown,
  Search,
  ExternalLink,
  Star,
  Facebook,
  Twitter,
  Linkedin,
  Mail,
  LanguagesIcon,
  ChevronRight,
  Link as LinkIcon,
  Video,
  Instagram,
  Music,
  MessageCircle,
  Send,
  Camera,
} from "lucide-react";
// ---------- Layout primitives ----------
const Container = ({ children }) => (
  <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
    {children}
  </div>
);

// Allow refs on Card so click-outside works correctly
const Card = forwardRef(function Card({ children, className = "" }, ref) {
  return (
    <div
      ref={ref}
      className={`rounded-3xl bg-white p-4 shadow-sm ring-1 ring-[#f2f2f2] ${className}`}
    >
      {children}
    </div>
  );
});

const Pill = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}
  >
    {children}
  </span>
);

const Button = ({
  variant = "primary",
  className = "",
  children,
  disabled = false,
  ...props
}) => {
  const base =
    "inline-flex items-center justify-center gap-[8px] rounded-2xl px-[20px] py-[8px] text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  const styles = {
    primary: "bg-[#34c3c9] text-white hover:brightness-95 focus:ring-[#34c3c9]",
    secondary:
      "bg-white text-[#34c3c9] ring-1 ring-[#34c3c9] hover:bg-[#f2f2f2] focus:ring-[#34c3c9]",
    ghost: "text-[#34c3c9] hover:bg-[#f2f2f2] focus:ring-[#34c3c9]",
  };
  return (
    <button
      className={`${base} ${styles[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

const Progress = ({ value }) => (
  <div className="h-2 w-full rounded-full bg-[#f2f2f2]">
    <div
      className="h-2 rounded-full bg-[#34c3c9]"
      style={{ width: `${Math.min(Math.max(value, 0), 100)}%` }}
    />
  </div>
);
const EventMap = ({ locationName }) => {
  const [coordinates, setCoordinates] = useState(null);

  const mapStyles = {
    height: "300px",
    width: "100%",
    borderRadius: "16px",
  };

  const handleMapLoad = () => {
    if (!locationName || !window.google) return;

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: locationName }, (results, status) => {
      if (status === "OK" && results[0]) {
        const { lat, lng } = results[0].geometry.location;
        setCoordinates({
          lat: lat(),
          lng: lng(),
        });
      } else {
        console.error("Geocoding failed:", status);
      }
    });
  };

  return (
    <LoadScript
      onLoad={handleMapLoad}
      googleMapsApiKey="AIzaSyDopg1y0GhLx_WTxXyoT-0MkOVQ34CmpDI"
    >
      {coordinates && (
        <GoogleMap mapContainerStyle={mapStyles} center={coordinates} zoom={15}>
          <Marker position={coordinates} />
        </GoogleMap>
      )}
    </LoadScript>
  );
};
const SilenrReadingAbout = () => {
  const { lg } = useContext(LanguageContext);

  const socket = useContext(SocketContext);
  const [searchParams] = useSearchParams();

  const { user, setShowLoginM } = ChatState();
  const [show, setShow] = useState(false); // For signup modal
  const [wShow, setWShow] = useState(false); // For signup modal
  const [sShow, setSShow] = useState(false); // For signup modal
  const [sLShow, setSLShow] = useState(false); // For signup modal

  // Handle closing both modals
  const handleClose = () => {
    setShow(false); // Close signup modal
  };
  // Handle closing both modals
  const handleCloseW = () => {
    setWShow(false);
    setShow(false); // Close signup modal
    if (user?.isAmbassador) {
      navigate("/leading"); // Navigate to home page
    } else {
      navigate("/leading");
    }
  };
  const handleCloseS = () => {
    setSShow(false); // Close signup modal
  };

  const handleCloseSL = () => {
    setSLShow(false);
    setSShow(false); // Close signup modal
  };

  // Handle opening Show modal

  const handleShow = () => {
    setShow(true); // Open signup modal
  };
  const handleShowS = () => {
    setSShow(true); // Open signup modal
  };

  const handleShowW = async () => {
    if (!user?._id) {
      setShowLoginM(true);
      // toast.error("You must be logged in");
      return;
    }
    if (!user?._id || !eventData?.userId?._id) {
      toast.error("Missing required user or event information");
      return;
    }
    if (user?._id == eventData?.userId?._id) {
      toast.error("Event creator could not join event as attendee.");
      return;
    }

    if (typeof spotsLeft === "number" ? spotsLeft > 0 : true) {
      if (socket) {
        socket.emit("request_chat", {
          userId: user?._id,
          ambassadorId: eventData?.userId?._id,
          eventData: eventData,
        });
        toast.success(lg?.yourRequestHasBeenSent || "Your request has been sent to the ambassador");
      } else {
        toast.error("You must be logged in to request a chat.");
      }
      try {
        // 1. Call API to update attendees
        const response = await axios.put(
          `api/v1/books/update-attendees/${eventData?.eventId}`,
          {
            attendeeIds: [...eventData?.attendees, user?._id], // Assuming you have currentUserId
          }
        );

        // 2. Only update state if API call succeeds
        if (response.status === 200) {
          setIsJoined(true);
          setSpotsLeft(spotsLeft - 1);
          setWShow(true); // Open signup modal
          setShow(false); // Open signup modal
          localStorage.setItem(
            "eventDataNew",
            JSON.stringify({
              ...eventData,
              attendees: [...eventData?.attendees, user?._id],
            })
          );
        }
      } catch (error) {
        console.error("Failed to join event:", error);
        // Optional: Show error to user
        toast.error(
          error.response?.data?.message || "Join failed. Please try later."
        );
      }
    }
    // setIsJoined(true); // Assuming you have a state variable 'isJoined' to track if the user has joined
  };
  useEffect(() => {
    const storedData = localStorage.getItem("eventDataNew");
    let std = JSON.parse(storedData);
    console.log(storedData, std?.attendees?.length, "storedData");

    if (storedData) {
      setEventData(std);
    }
  }, []);
  const [buyMenuOpen, setBuyMenuOpen] = useState(false);
  const [activeCountry, setActiveCountry] = useState(null);
  const [buyQuery, setBuyQuery] = useState("");
  const buyMenuRef = useRef(null);
  const hasManuallySelectedCountry = useRef(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setBuyMenuOpen(false);
    const onClick = (e) => {
      if (buyMenuRef.current && !buyMenuRef.current.contains(e.target))
        setBuyMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClick);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClick);
    };
  }, []);
  const handleShowSL = () => {
    setSLShow(true);
    setSShow(false); // Open signup modal
  };
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [countries, setCountries] = useState([]);
  const [buyCatalog, setBuyCatalog] = useState({}); // { "United Kingdom": [...], ... }

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const { data } = await axios.get("api/v1/stores/");

        // Transform into { country: [stores] } shape
        const catalog = {};
        data.forEach((entry) => {
          catalog[entry.country.trim()] = entry.stores.map((store) => ({
            name: store.name,
            url: store.link,
          }));
        });

        console.log("Transformed buyCatalog:", catalog);
        setBuyCatalog(catalog);

        const countryList = data.map((entry) => entry.country.trim());
        console.log("Countries list:", countryList);
        setCountries(countryList);
      } catch (error) {
        console.error("Error fetching stores:", error);
      }
    };

    fetchStores();
  }, []);
  const filteredCountries = countries.filter((country) =>
    country.toLowerCase().includes(buyQuery.toLowerCase())
  );
  const [totalSpots, setTotalSpots] = useState(10);
  const [spotsLeft, setSpotsLeft] = useState();
  useEffect(() => {
    const storedData = localStorage.getItem("eventDataNew");
    if (!storedData) return;

    const parsedData = JSON.parse(storedData);

    if (parsedData?.attendees?.includes(user?._id)) {
      setIsJoined(true);
    }
  }, [user?._id]);

  const [eventData, setEventData] = useState({});
  const [isJoined, setIsJoined] = useState(false);
  const eventId = searchParams.get("bookid");
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let pct = null;
  useEffect(() => {
    const getEventData = async () => {
      if (eventId) {
        // If eventId exists, fetch from backend
        try {
          const res = await axios.get(`api/v1/books/${eventId}`, {
            headers: { "x-timezone": userTimeZone },
          });
          const raw = res.data;
          if (raw?.maxAttendee === "no-limit") {
            setSpotsLeft(lg?.noLimit || "No Limit");
            setTotalSpots(lg?.noLimit || "No Limit");
          } else {
            const spotsLeft =
              Number(raw?.maxAttendee) - (raw?.attendees?.length || 0);
            setSpotsLeft(spotsLeft);
            pct = Math.round(
              ((raw?.maxAttendee - spotsLeft) / raw?.maxAttendee) * 100
            );
            setTotalSpots({ max: raw?.maxAttendee, min: raw?.minAttendee });
          }
          setEventData(formatEventData(raw, eventId));
        } catch (error) {
          console.error("Error fetching event data", error);
          // If fetch fails, try localStorage as fallback
          checkLocalStorage();
        }
      } else {
        // If no eventId, check localStorage
        checkLocalStorage();
      }
    };
    const formatEventData = (raw, id) => {
      console.log(raw, "raw data in eventData");

      return {
        type: raw.name,
        pages: raw.pageNumber || "",
        city: raw.city || "",
        venue: raw.location?.name || "",
        link: raw.link || "",
        title: raw.title || "",
        image: raw.image || "",
        author: raw.author || "",
        age: raw.age || "",
        language: raw.language || "",
        gender: raw.gender || "Unspecified",
        detail: raw.description || "",
        eventType: raw.type || "",
        createdAt: raw?.dateInfo,
        time: raw?.timeTrack,
        localTime: raw?.localTime || null, // ✅ Backend-converted time to viewer's timezone
        userId: raw.userId || {},
        meetingLink: raw.meetingLink || "",
        eventId: raw._id || id,
        attendees: raw.attendees || [],
        LangLat: raw.location || null,
        location:raw?.location?.name ,
        utcTime: raw.globalTime,
      };
    };
    const checkLocalStorage = () => {
      const storedData = localStorage.getItem("eventDataNew");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setEventData(parsedData);
      }
    };

    getEventData();
  }, [eventId]);
  // MODEL SHARE LINK?
  const shareEvent = (platform) => {
    const eventId = eventData?.eventId || "defaultId"; // fallback if _id is missing
    const textToShare = `${Frontend}/silentreadingabout?id=${eventId}`;
    const encodedText = encodeURIComponent(`Check this out: ${textToShare}`);

    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodedText}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          textToShare
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedText}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          textToShare
        )}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
          textToShare
        )}&text=${encodedText}`;
        break;
      case "email":
        shareUrl = `mailto:?subject=Check%20this%20event&body=${encodedText}`;
        break;
      case "copy":
        navigator.clipboard.writeText(textToShare).then(() => {
          toast.success("Link copied to clipboard!");
        });
        return;
      default:
        return;
    }

    window.open(shareUrl, "_blank");
  };

  const [isMapsLoaded, setIsMapsLoaded] = useState(false);
  const center = useMemo(
    () => ({
      lat: eventData?.LangLat?.coordinates?.[1] ?? 0,
      lng: eventData?.LangLat?.coordinates?.[0] ?? 0,
    }),
    [eventData]
  );

  // 2. Custom marker icon (only created after google.maps is available)
  const [markerIcon, setMarkerIcon] = useState(null);

  // After Google Maps is loaded

  const shortToFullMonth = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };
  const [showJoined, setShowJoined] = useState(false);
  const [showShare, setShowShare] = useState(false);

  // Example:
  const shortMonth = eventData?.createdAt?.month; // e.g., "Jan"
  const fullMonth = shortToFullMonth[shortMonth] || shortMonth; // fallback in case undefined

  // Format time to 24-hour format (HH:mm)
  function formatTime24(time24) {
    if (!time24) return "";
    
    // Handle both "HH:mm" string format and number format
    let hours, minutes;
    if (typeof time24 === "string" && time24.includes(":")) {
      [hours, minutes] = time24.split(":").map(Number);
    } else if (typeof time24 === "number") {
      hours = time24;
      minutes = 0;
    } else {
      return "";
    }

    // Ensure 24-hour format: HH:mm
    const hoursStr = hours.toString().padStart(2, "0");
    const minutesStr = minutes ? minutes.toString().padStart(2, "0") : "00";

    return `${hoursStr}:${minutesStr}`;
  }

  // Use localTime (converted by backend) if available, otherwise fallback to original time
  const displayTime = eventData?.localTime 
    ? formatTime24(eventData.localTime)
    : eventData?.time?.minutes 
    ? (() => {
        const hour = eventData.time.minutes;
        const minutes = eventData.time.seconds || 0;
        return formatTime24(`${hour}:${minutes.toString().padStart(2, "0")}`);
      })()
    : "";
  const getLanguageName = (code) => {
    try {
      return new Intl.DisplayNames(["en"], { type: "language" }).of(code);
    } catch {
      return code || "Unknown";
    }
  };
  const fullAddress = `${eventData?.venue}, ${eventData?.city}`;
  const encoded = encodeURIComponent(fullAddress);

  //new
  //Added new code here
  const TitleStyles = () => (
    <style>{`
      .book-title { font-size: clamp(1.25rem, 2vw + 0.5rem, 2rem); line-height: 1.2; word-break: break-word; overflow-wrap: anywhere; hyphens: auto; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; }
      @media (max-width: 639px) { .book-title { -webkit-line-clamp: 2; } }
      @media (min-width: 640px) { .book-title { -webkit-line-clamp: 2; } }
      @media (min-width: 1024px) { .book-title { -webkit-line-clamp: 3; } }
    `}</style>
  );
  // Stars with half support
  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => {
      const full = i + 1 <= Math.floor(rating);
      const half = !full && i < rating;
      return (
        <div
          key={i}
          className="relative h-[17px] w-[17px]"
          data-testid={`star-${i}`}
        >
          <Star className="absolute inset-0 h-[17px] w-[17px] text-gray-300" />
          {full && (
            <Star className="absolute inset-0 h-[17px] w-[17px] text-yellow-400 fill-yellow-400" />
          )}
          {half && (
            <Star
              className="absolute inset-0 h-[17px] w-[17px] text-yellow-400"
              style={{ clipPath: "inset(0 50% 0 0)" }}
              fill="#fbbf24"
            />
          )}
        </div>
      );
    });

  // const spotsLeft = mock.totalSpots - mock.takenSpots;
  // const pct = Math.round(
  //   ((totalSpots?.max - spotsLeft) / totalSpots?.max) * 100
  // );
  //const shareUrl = `${Frontend}/meetorganizer?id=${eventId}`;

  // Social share
   const eventTitle = `Check out this event! ${eventData?.title}` || "Check out this event!";
      const eventImage = `${BASE_URL}/uploads/${eventData?.image}`;
    
    
      const baseApiUrl = `${BASE_URL}/share`;
      const shareUrl = `${baseApiUrl}/${eventData?.eventId}`; // this is the new backend route
      const encodedUrl = encodeURIComponent(shareUrl);
      const encodedTitle = encodeURIComponent(eventTitle || "Check out this event!");
  return (
    <>
      <div className="position-fixed z-2 w-100 left-0  top-0  grouup">
        <Header3 />
      </div>

      <div className="min-h-screen bg-gradient-to-b from-white to-[#f2f2f2] pb-52 pt-[118px]">
        <TitleStyles />
        <Container>
          {/* Top grid */}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
            {/* Cover + Details */}
            <Card className="md:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Book cover + stars */}
              <div className="md:col-span-1 flex flex-col items-center">
                <div className="relative aspect-[2/3] w-full max-w-[300px] overflow-hidden rounded-md shadow-lg ring-1 ring-[#d1d1d1]">
                  <img
                    src={require("../pages/image/book7.jpg")}
                    style={{
                      opacity: spotsLeft === 0 ? 0.3 : 1, // Dim the image when spotsLeft is 0
                    }}
                    alt="Book cover"
                    className="h-full w-full object-cover cursor-pointer"
                  />

                  {spotsLeft === 0 && (
                    <div
                      className="fw-bold rounded-1 fontfull"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%) rotate(-70deg)",
                        color: "red",
                        fontSize: "52px",
                        backgroundColor: "transparent",
                        padding: "2px 35px",
                        border: "5px solid red",
                        textTransform: "uppercase",
                      }}
                    >
                      Full
                    </div>
                  )}
                </div>
              </div>

              {/* Right column */}
              {eventData && (
                <div className="md:col-span-2">
                  <div className="flex flex-wrap items-center gap-2">
                    <Pill className="bg-[#d9ead3] text-slate-700">
                      {lg?.bookSilentTitle || "Silent Reading"}
                    </Pill>
                  </div>
                  <h1
                    className="mt-2 book-title font-semibold tracking-tight"
                    title={lg?.yownbook}
                    data-testid="book-title"
                  >
                    {lg?.yownbook}
                  </h1>

                  <div className="mt-4 space-y-2 text-sm">
                    <div className="flex items-start gap-2 text-slate-700">
                      <CalendarDays className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium"> {lg?.when}:</span>{" "}
                        {(() => {
                          // Translate day abbreviation
                          const dayMap = {
                            "Mon": lg?.dayMon || "Mon",
                            "Tue": lg?.dayTue || "Tue",
                            "Wed": lg?.dayWed || "Wed",
                            "Thu": lg?.dayThu || "Thu",
                            "Fri": lg?.dayFri || "Fri",
                            "Sat": lg?.daySat || "Sat",
                            "Sun": lg?.daySun || "Sun",
                          };
                          const translatedDay = dayMap[eventData?.createdAt?.dayName] || eventData?.createdAt?.dayName;
                          return translatedDay + ",  " + eventData?.createdAt?.day + " " + fullMonth + " " + eventData?.createdAt?.year;
                        })()}
                        {displayTime && (
                          <span className="ml-2 font-medium text-[#34c3c9]">
                            at {displayTime}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      {eventData?.eventType === "On-line" ? (
                        <Video className="mt-0.5" size={18} />
                      ) : (
                        <MapPin className="mt-0.5" size={18} />
                      )}
                      <div>
                        <span className="font-medium"> {lg?.where}:</span>{" "}
                        {eventData?.eventType === "On-line" ? (
                          isJoined ? (
                            <a
                              href={eventData?.meetingLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-[#34c3c9] hover:underline"
                              style={{
                                cursor: "pointer",
                                opacity: "1",
                                fontSize: "16px",
                              }}
                            >
                              {eventData?.meetingLink}
                            </a>
                          ) : (
                            <>
                              On-line
                              <span style={{ fontSize: "13px", color: "gray" }}>
                                – Link visible to attendees only
                              </span>
                            </>
                          )
                        ) : (
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                              `${eventData?.location}, ${eventData?.city}`
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#34c3c9] hover:underline"
                          >
                            {eventData?.location && `${eventData?.location},`}
                            {eventData?.city}
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      <User className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium cursor-pointer">
                          {eventData?.userId?.isAmbassador
                            ? (lg?.ambassadorLabel || "Ambassador:")
                            : (lg?.createdBy || "Created BY:")}
                        </span>{" "}
                        <span
                          className="text-[#34c3c9] hover:underline cursor-pointer"
                          onClick={() => {
                            if (!user?._id) {
                              setShowLoginM(true)
                            }
                            else
                              navigate(
                                `/ambassadorprofile?id=${eventData?.userId?._id}`
                              )
                          }}
                        >
                          {eventData?.userId?.name}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      <Globe className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium"> {lg?.language}:</span>{" "}
                        {getLanguageName(eventData?.language)}
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-slate-700">
                      <Crown className="mt-0.5" size={18} />
                      <div>
                        <span className="font-medium"> {lg?.age}:</span>{" "}
                        {eventData?.age}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Card>
            {/* Map & Buy (Buy on resides here, above the map) */}
            <Card className="md:col-span-5 !p-4" ref={buyMenuRef}>
              {/* Buy on (Nested dropdown) */}
              <div className="mb-6">
                <label className="mb-3 block text-sm font-semibold text-slate-700">
                  {lg?.buyon || "Buy on"}
                </label>
                <button
                  type="button"
                  onClick={() => setBuyMenuOpen((v) => !v)}
                  className="flex w-full max-w-md items-center justify-between rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 text-sm text-slate-800 hover:bg-[#fafafa] transition-colors"
                  aria-expanded={buyMenuOpen}
                >
                  <span>{activeCountry || (lg?.chooseYourCountry || "Choose your country")}</span>
                  <ChevronDown className={`h-4 w-4 transition-transform ${buyMenuOpen ? 'rotate-180' : ''}`} />
                </button>

                {buyMenuOpen && (
                  <div className="relative z-20 mt-2 w-full max-w-2xl overflow-hidden rounded-2xl border border-[#e5e5e5] bg-white shadow-xl">
                    {/* Search */}
                    <div className="border-b border-[#f0f0f0] p-3">
                      <div className="relative">
                        <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-[#a6a6a6]" />
                        <input
                          value={buyQuery}
                          onChange={(e) => setBuyQuery(e.target.value)}
                          placeholder="Search country..."
                          className="w-full rounded-lg border border-[#e5e5e5] bg-white py-2 pl-9 pr-3 text-sm focus:border-[#34c3c9] focus:outline-none"
                        />
                      </div>
                    </div>

                    {/* Two-pane nested menu */}
                    <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
                      {/* Countries */}
                      <div className="max-h-80 overflow-auto">
                        {filteredCountries.length === 0 ? (
                          <div className="px-4 py-8 text-center text-sm text-slate-500">
                            No countries found
                          </div>
                        ) : (
                              filteredCountries.map((c) => (
                                <button
                                  key={c}
                                  onClick={() => {
                                    hasManuallySelectedCountry.current = true;
                                    setActiveCountry(c);
                                  }}
                                  className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm hover:bg-[#f9f9f9] transition-colors ${
                                    activeCountry === c
                                      ? "bg-[#f6fffe] text-[#0f766e] font-medium"
                                      : ""
                                    }`}
                                >
                                  <span>{c}</span>
                                  <ChevronDown className="h-4 w-4 -rotate-90" />
                                </button>
                              ))
                        )}
                      </div>

                      {/* Sellers */}
                      <div className="border-t border-[#f2f2f2] sm:border-l sm:border-t-0 max-h-80 overflow-auto">
                        {!activeCountry ? (
                          <div className="px-4 py-8 text-center text-sm text-slate-500">
                            <p className="mb-1">Select a country to see sellers</p>
                            <p className="text-xs text-slate-400">Choose from the list on the left</p>
                          </div>
                        ) : !buyCatalog[activeCountry] || buyCatalog[activeCountry].length === 0 ? (
                          <div className="px-4 py-8 text-center text-sm text-slate-500">
                            <p className="mb-1">No sellers available</p>
                            <p className="text-xs text-slate-400">for {activeCountry}</p>
                          </div>
                        ) : (
                          <div>
                            <div className="sticky top-0 bg-white border-b border-[#f2f2f2] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
                              {activeCountry} ({buyCatalog[activeCountry]?.length || 0} {buyCatalog[activeCountry]?.length === 1 ? 'seller' : 'sellers'})
                            </div>
                            <div className="divide-y divide-[#f2f2f2]">
                              {buyCatalog[activeCountry]?.map((s, index) => (
                                <a
                                  key={s.name || index}
                                  href={s.url || s.link || '#'}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="flex items-center justify-between px-4 py-3 text-sm hover:bg-[#f6fffe] transition-colors group"
                                  onClick={() => setBuyMenuOpen(false)}
                                >
                                  <span className="font-medium text-slate-700 group-hover:text-[#34c3c9] transition-colors">{s.name}</span>
                                  <ExternalLink className="h-4 w-4 text-[#a6a6a6] group-hover:text-[#34c3c9] transition-colors" />
                                </a>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {eventData?.eventType === "In-person" ? (
                <div className="mt-0 overflow-hidden rounded-2xl ring-1 ring-[#f2f2f2]">
                  <div className=" h-[300px] w-full ">
                    <a
                       href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        `${eventData?.location}, ${eventData?.city}`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        textDecorationLine: "underline",
                        fontSize: "20px",
                      }} // Preserve styles and text color
                    >
                      {" "}
                      {eventData?.eventType === "In-person" && (
                        <EventMap
                          locationName={`${eventData?.location?.location}, ${eventData?.city}`}
                        />
                      )}
                    </a>
                  </div>
                </div>
              ) : (
                <>
                  <div className="mt-0 grid h-[200px] w-full place-items-center rounded-2xl bg-[conic-gradient(at_top_left,_#e8f9fa,_#ffffff)] text-sm text-[#a6a6a6]">
                    {isJoined ? (
                      <a
                        href={eventData?.meetingLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#34c3c9] hover:underline"
                        style={{
                          cursor: "pointer",
                          opacity: "1",
                          fontSize: "16px",
                        }}
                      >
                        <Video size={28} className="text-[#34c3c9]" />
                      </a>
                    ) : (
                      <Video size={28} className="text-[#34c3c9]" />
                    )}
                  </div>
                  <p className="mt-2 text-center text-xs text-slate-500">
                    {isJoined ? "Click on the camera to join the meeting" : " Link visible to attendees only"}
                  </p>
                </>
              )}
            </Card>
          </div>
          {/* About */}
          <div className="mt-10">
            <Card className="md:col-span-12">
              {/* <h2 className="text-lg font-semibold">{lg?.aboutbook}</h2>
              <div className="mt-3 space-y-3 text-sm leading-6 text-slate-700">
                <p></p>
              </div> */}
              <h2 className="text-lg font-semibold">{lg?.details || "Details"}</h2>
              <div className="mt-3 space-y-3 text-sm leading-6 text-slate-700">
                <p style={{ whiteSpace: "pre-wrap" }}>{eventData?.detail}</p>
              </div>
            </Card>
          </div>
        </Container>

        {/* Sticky bottom banner */}
        <div className="fixed inset-x-0 bottom-0 z-[300] bg-[#d9d9d9] shadow-[0_-4px_16px_rgba(0,0,0,0.15)] ring-1 ring-[#b3b3b3]">
          <div className="mx-auto w-full max-w-7xl px-6">
            <div className="flex flex-col items-center gap-4 py-[20px] sm:flex-row sm:justify-between">
              <div className="flex items-center gap-8 w-full sm:w-auto">
                <Pill className="bg-[#d9ead3] text-slate-700">
                  {" "}
                  {lg?.bookSilentTitle || "Silent Reading"}
                </Pill>

                <div className="text-sm text-slate-700 font-medium">
                  {typeof spotsLeft === "number" && typeof totalSpots === "object" && totalSpots?.max
                    ? `${totalSpots.max - spotsLeft}/${totalSpots.max} joined . `
                    : ""}
                  {spotsLeft} {lg?.spotleft || "spots left"}
                </div>

                <div className="hidden w-80 sm:block">
                  {typeof spotsLeft === "number" && typeof totalSpots === "object" && totalSpots?.max ? (
                    <Progress value={pct} />
                  ) : null}
                </div>
              </div>
              <div className="flex w-full justify-end gap-3 sm:w-auto">
                <Button
                  variant={isJoined ? "secondary" : "primary"}
                  onClick={(e) => {
                    if (!user?._id) {
                      setShowLoginM(true);
                      return;
                    } else {
                      handleShowW(e);
                    }
                  }}
                  disabled={(typeof spotsLeft === "number" && spotsLeft === 0) || isJoined}
                  aria-pressed={isJoined}
                  data-testid="join-button"
                  className="min-w-[100px]"
                >
                  {typeof spotsLeft === "number" && spotsLeft === 0 ? (
                    <>{lg?.full || "Full"}</>
                  ) : isJoined ? (
                    <>
                      <Check size={16} /> {lg?.joinedCapitalized || "Joined"}
                    </>
                  ) : (
                    lg?.join || "Join"
                  )}
                </Button>
                <Button
                  disabled={typeof spotsLeft === "number" && spotsLeft === 0}
                  variant="secondary"
                  onClick={() => setShowShare(true)}
                  className="min-w-[100px]"
                >
                  <Share2 size={16} /> {lg?.share || "Share"}
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Share modal */}
       {showShare && (
                 <div className="fixed inset-0 z-50 flex items-center justify-center">
                   <div
                     className="absolute inset-0 bg-black/40"
                     onClick={() => setShowShare(false)}
                   />
                   <div className="relative z-10 w-full max-w-lg rounded-2xl border-2 border-[#34c3c9] bg-white p-6 shadow-xl mx-4">
                     <div className="mb-3 flex items-start justify-between">
                       <h3 className="text-xl font-semibold text-[#0f172a]">
                         {lg?.shareThisEvent || "Share this event"}
                       </h3>
                       <button
                         className="text-slate-500"
                         onClick={() => setShowShare(false)}
                         aria-label="Close share"
                       >
                         ✕
                       </button>
                     </div>
                     <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                       {/* WhatsApp */}
                       <a
                         href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <MessageCircle className="h-4 w-4" /> WhatsApp
                       </a>

                       {/* Facebook */}
                       <a
                         href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Facebook className="h-4 w-4" /> Facebook
                       </a>

                       {/* Telegram */}
                       <a
                         href={`https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Send className="h-4 w-4" /> Telegram
                       </a>

                       {/* Instagram (no API, fallback to link) */}
                       <a
                         href={shareUrl}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Instagram className="h-4 w-4" /> Instagram
                       </a>
       
                       {/* TikTok */}
                       <a
                         href={`https://www.tiktok.com/share?url=${encodedUrl}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Music className="h-4 w-4" /> TikTok
                       </a>
       
                       {/* Twitter/X */}
                       <a
                         href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Twitter className="h-4 w-4" /> X/Twitter
                       </a>
       
                       {/* LinkedIn */}
                       <a
                         href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Linkedin className="h-4 w-4" /> LinkedIn
                       </a>
       
                       {/* Snapchat */}
                       <a
                         href={`https://www.snapchat.com/scan?attachmentUrl=${encodedUrl}`}
                         target="_blank"
                         rel="noreferrer"
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Camera className="h-4 w-4" /> Snapchat
                       </a>
       
                       {/* Copy link */}
                       <button
                         onClick={() =>
                           navigator.clipboard.writeText(shareUrl).then(() => {
                             toast.success("Link copied to clipboard!");
                           })
                         }
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <LinkIcon className="h-4 w-4" /> Copy link
                       </button>
       
                       {/* Email */}
                       <a
                         href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}
                         className="flex items-center gap-2 rounded-xl border px-3 py-2 text-sm hover:bg-[#f9f9f9]"
                       >
                         <Mail className="h-4 w-4" /> Email
                       </a>
                     </div>
                   </div>
                 </div>
               )}

        {/* Joined confirmation modal */}
        {showJoined && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setShowJoined(false)}
            />
            <div className="relative z-10 w-full max-w-2xl rounded-2xl border-2 border-[#34c3c9] bg-white p-6 shadow-xl">
              <div className="mb-3 flex items-start justify-between">
                <h3 className="text-xl font-semibold text-[#0f172a]">
                  {lg?.welldone}
                </h3>
                <button
                  className="text-slate-500"
                  onClick={() => {
                    setShowJoined(false);
                    if (user?.isAmbassador) {
                      navigate("/leading"); // Navigate to home page
                    } else {
                      navigate("/leading");
                    }
                  }}
                  aria-label="Close joined"
                >
                  ✕
                </button>
              </div>
              <p className="text-center text-sm sm:text-base text-slate-800 font-medium mb-2">
                {lg?.attending}{" "}
                <span className="font-semibold">
                  {" "}
                  {eventData?.title ? eventData?.title + " - " : " "}
                  Book Club!
                </span>
                !
              </p>
              <p className="text-center text-sm text-slate-600">
                {lg?.attendmsg}
              </p>
            </div>
          </div>
        )}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="custom-gropmodel heigh"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold  mx-md-4 px-md-2 mt-3 mt-sm-0 aboutauther  text-center"
            style={{ fontSize: "27px" }}
          >
            {/* Complete your registration */}
            {lg?.cregistration}
          </div>
        </Modal.Title>
        <Modal.Body className="mx-auto mt-2">
          {/* <div className="d-flex mx-3 mx-md-0 gap-1">
            <img
              className="my-1"
              src={require("./image/modalemail.png")}
              width="20"
              height="20"
              style={{ width: "20px", height: "20px" }}
            />
            <div
              className="fs-5 fw-normal  text-center  w-100 ftzcopy   "
              style={{ maxWidth: "550px" }}
            >
             
              {lg?.registrationmsg}
            </div>
          </div> */}

          <div className=" text-center ">
            <button
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "200px ",
                fontSize: "22px",
                height: "45px",
                backgroundColor: "#34C3C9",
                padding: "0px 20px",
              }}
              onClick={handleShowW}
            >
              {/* Submit */}
              {lg?.submitbtn}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {wShow && (
        <div className="fixed inset-0 flex items-center justify-center  bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-lg border border-teal-300 p-8 max-w-xl w-full relative">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-left">
              Well done!
            </h2>
            <p className="text-lg font-semibold text-gray-900 mb-1 text-center">
              {lg?.youAreAttendingThis || "You are attending this"}{" "}
              <span className="font-bold">{lg?.bookSilentTitle || "Silent Reading"}</span>!
            </p>
            <p className="text-gray-600 text-center">
              {lg?.youCanNowSeeThisEvent || "You can now see this event in your Ofellio's dashboard and chat"}{" "}
              {lg?.withYourAmbassador || "with your Ambassador"}
            </p>
            <button
              onClick={handleCloseW}
              className="absolute top-5 right-6 text-gray-400 hover:text-gray-600 text-xl"
            >
              ×
            </button>
          </div>
        </div>
      )}
      <Modal
        show={false}
        onHide={handleCloseW}
        centered
        className="custom-gropmodelwel weldonemodel"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn24 mt-1 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold mx-sm-2 text-center  aboutauther  "
            style={{ fontSize: "27px", color: "#34C3C9" }}
          >
            {/* Well done! */}
            {lg?.welldone}
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 pt-0 mt-sm-3 mt-2">
          <div
            className=" fw-bold mx-lg-3  text-center  w-100 ftzcopy   "
            style={{ fontSize: "20px" }}
          >
            {/* You’re attending */}
            {lg?.attending}
            Silent Reading!
          </div>
          <div
            className=" fw600 mx-lg-3 text-center  mt-sm-3 mt-2   w-100 ftzcopy   "
            style={{ fontSize: "18px" }}
          >
            {/* You can now see this event in your Ofellio’s dashboard and chat with
            your Ambassador. */}
            {lg?.attendmsg}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={sShow}
        onHide={handleCloseS}
        centered
        className="custom-gropshare"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn closebtnevtn3"
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseS}
          />
        </Modal.Header>
        <Modal.Title className="mx-auto  ">
          <div
            className=" fw-bold text-center  aboutauther  "
            style={{ fontSize: "27px" }}
          >
            {lg?.shareThisEvent || "Share this event"}
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 ">
          <div className="d-flex gapimgmodel mt-sm-2 mx-sm-5 flex-wrap justify-content-center">
            <img
              src={require("./image/whatsappmodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}

              onClick={() => shareEvent("whatsapp")}
            />
            <img
              src={require("./image/fbmodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("facebook")}
            />
            <img
              src={require("./image/telegrmmodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("telegram")}
            />
            <img
              src={require("./image/instamodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("instagram")}
            />
            <img
              src={require("./image/tiktkomodel.png")}
              width="35"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("tiktok")}
            />
            <img
              src={require("./image/twetrmodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("twitter")}
            />
            <img
              src={require("./image/linkedmodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("linkedin")}
            />
            <img
              src={require("./image/modeemail.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("email")}
            />
            <img
              src={require("./image/copymodel.png")}
              width="40"
              height="40"
              // onClick={handleShowSL}
              onClick={() => shareEvent("copy")} // ✅ Corrected onClick handler
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={sLShow}
        onHide={handleCloseSL}
        centered
        className="custom-gropshresend"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn closebtnevtn4 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseSL}
          />
        </Modal.Header>
        <Modal.Title className="mx-5  ">
          <div
            className=" fw-bold mx-sm-2 text-center  abcftz  "
            style={{ fontSize: "27px" }}
          >
            Great! You will discuss the details of the 1:1 with{" "}
            <span className="fst-italic" style={{ color: "#34C3C9" }}>
              {" "}
              [NAME OF THE ORGANIZER].
            </span>
          </div>
        </Modal.Title>
        <Modal.Body className="mx-5 mt-md-2 mt-0">
          <div
            className=" fw-normal mx-md-4 mx-2 text-center  w-100 fontmobil   "
            style={{ maxWidth: "592px", fontSize: "17px" }}
          >
            Send a custom message using the box below, once done, the organizer
            will decide if accepting your request.
          </div>
          <div className="mx-2 mt-md-3">
            <div className="fs-5 fw-bold ftlink">Send a message</div>

            <textarea
              type="text"
              className="form-control my-1 w-100  fw-normal fontmobil fs-6 bg-transparent  rounded-1 placeholder-login"
              id="text"
              placeholder="Hi [NAME OF THE ORGANAZIER],
I have an interest in your 1:1, I would like to join and discuss over this book because.…"
              style={{
                border: "2px solid #000000",
                maxWidth: "680px",
                height: "187px",
                color: "#5B5B5B",
              }}
            />
          </div>

          <div className="mt-sm-4 mt-3 text-center ">
            <button
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "162px ",
                fontSize: "22px",
                height: "45px",
                backgroundColor: "#34C3C9",
              }}
            >
              Send
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SilenrReadingAbout;
